import { Component } from 'react'
import Notes from 'components/Notes'

class NotesWindow extends Component {
  state = {
    value: '',
    position: 'window'
  }

  componentDidMount() {
    this.setState({ value: sessionStorage.getItem('notes') || '' })
  }

  dispatchEvent(type, value) {
    opener.postMessage({ type, value }, '*')
  }

  handleChange = (e) => {
    this.dispatchEvent('notesUpdate', e.target.value)
    this.setState({ value: e.target.value })
  }

  changePosition = (position) => {
    this.setState({ position })
    this.dispatchEvent('notesPosition', position)
  }

  handleBlur = () => {
    this.dispatchEvent('notesBlur')
  }

  render() {
    const props = {
      ...this.state,
      changePosition: this.changePosition,
      handleChange: this.handleChange,
      handleBlur: this.handleBlur
    }

    return <Notes {...props} />
  }
}

export default NotesWindow
